export enum InspectionDrawingTools {
    Draw = "Draw",
    Select = "Select",
    BoxSelect = "BoxSelect",
    BoxZoom = "BoxZoom",
}
